import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_api/hello')({
  loader: () => {
    return { message: 'Hello from the L API!' }
  },
  component: () => null,
})
